module.exports = __webpack_public_path__ + "static/img/quxiaoquantijingyin.4125bc0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/quxiaoquantijingyin.png
// module id = 4Cvs
// module chunks = 24